export const getNormalizedBrand = (brand) => {
    if (!brand) return null;
    return String(brand).toLowerCase().trim().replaceAll(" ", "_").replaceAll("-", "_").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}